__webpack_require__.p = "/universal-connectivity/_next/";